import type { Ad } from '@/api/types/common.types';
import type { AdsChunkSize } from '@/components/AdsWithInfiniteScroll/AdsWithInfiniteScroll.types';
import type { AdDetails, DeleteReason } from '@/api/types/ads.types';

export type CurrentUserAdCounters = {
  archived: number;
  awaitingPayment: number;
  expired: number;
  pending: number;
  published: number;
  rejected: number;
};

export type MyAdsListResponse = {
  currentUserAds?: {
    nodes?: Ad[];
    pageInfo?: {
      endCursor?: string | null;
      hasNextPage: boolean;
    };
  };
};

export type CurrentUserAdStatus =
  | 'PUBLISHED'
  | 'AWAITING_PAYMENT'
  | 'EXPIRED'
  | 'PENDING'
  | 'REJECTED'
  | 'ARCHIVED';

export type MyAdsListVariables = {
  status: CurrentUserAdStatus;
  first: AdsChunkSize;
  after?: string | null;
};

export type CurrentUserCountersResponse = {
  currentUserCounters: CurrentUserAdCounters;
};

export type MyAdPromotionDetails = Pick<
  AdDetails,
  | 'id'
  | 'legacyResourceId'
  | 'status'
  | 'updatedAt'
  | 'kinds'
  | 'vippedUntil'
  | 'featuredUntil'
  | 'bumpServices'
  | 'vipServices'
  | 'featuredServices'
  | 'paymentMethods'
  | 'isAppleGooglePayEnabled'
>;

export type MyAdPromotionDetailsResponse = {
  node?: MyAdPromotionDetails | null;
};

export type MyAdPromotionDetailsVariables = {
  id: string;
};

export type MyAdDeleteReasonsResponse = {
  node?: {
    id: string;
    deleteReasons: DeleteReason[];
  } | null;
};

export type MyAdDeleteReasonsVariables = {
  id: string;
};

export type BulkPromotionServiceOption = {
  serviceId: string;
  name: string;
  amount: number;
  default: boolean;
};

export enum BulkPromotionServiceType {
  BUMP = 'BUMP',
  FEATURE = 'FEATURE',
  VIP = 'VIP',
}

export type BulkPromotionService = {
  serviceType: BulkPromotionServiceType;
  title: string;
  options: BulkPromotionServiceOption[];
};

export type BulkPromotionServiceOptionsResponse = {
  paymentServiceOptions: BulkPromotionService[];
};

export type BulkPromotionServiceOptionsVariables = {
  targetIds: string[];
};
